export function setCookieNotification(){
  return {
    type: 'SET_COOKIE_NOTIFICATION'
  }
}
